<template>
<div>
<div id="kv">
  <h1>すでにオーナー番号を<br class="sp">お持ちの方のご登録</h1>
</div>
<main class="lp">
  <section class="content">
    <div class="container">
      <p class="lead txt_center">マジェスティのクラブをご購入し、ご登録された方だけが入会できる<br class="pc">マジェスティ オーナーズクラブの会員限定のサイトになります。</p>
      <p class="lead txt_center">マジェスティオーナー様番号をお持ちで、初めて当WEBサイトにログインされる場合は、こちらからご登録ください。<br>オーナー様番号と、 生年月日か電話番号のどちらかの情報が確認できましたら、<br class="pc">ご登録のメールアドレスにパスワードを設定するURLを送信致します。
</p>
    </div>
  </section>
  <section class="content">
    <div class="container">
      <div class="item_login widthWide">
<ValidationObserver ref="observer" v-slot="{valid}">
        <form>
          <div class="ttl">
            <div class="icon"><img src="/assets/images/common/icon_h.svg"></div>
            <h2>すでにオーナー番号を<br>お持ちの方のご登録</h2>
          </div>
          <div class="item">
<ValidationProvider vid="id" name="id" rules="id-required|id-integer|id-exists" v-slot="{ errors }" mode="lazy" slim>
            <input type="text" name="id" placeholder="マジェスティオーナー様番号" v-model="form.id" @change="existBirthdayInOwnerData()">
</ValidationProvider>
          </div>
          <div class="boxWrap">
            <div class="txt_caution">※生年月日か電話番号の<br class="pc"><span>どちらかを入力</span>してください。</div>
            <div class="item select">
              <div class="ttl_form">
                <label for="birth">生年月日</label>
              </div>
              <div class="part_form">
<ValidationProvider vid="birthdayYear" name="birthdayYear" :rules="''" v-slot="{ errors }" mode="lazy" slim>
                <select name="year" id="year" v-model="form.birthdayYear" @change="existBirthdayInOwnerData()">
                  <option value="">-</option>
                  <option v-for="n in whileCurrentYear()" v-bind:value="n + 1929">{{ n + 1929 }}</option>
                </select>
</ValidationProvider>
                <span>年</span>
<ValidationProvider vid="birthdayMonth" name="birthdayMonth" :rules="''" v-slot="{ errors }" mode="lazy" slim>
                <select name="birthdayMonth" id="month" v-model="form.birthdayMonth" @change="existBirthdayInOwnerData()">
                  <option value="">-</option>
                  <option v-for="n in 12" v-bind:value="n">{{ n }}</option>
                </select>
</ValidationProvider>
                <span>月</span>
<ValidationProvider vid="birthdayDay" name="birthdayDay" :rules="validationRulesForAuthData('birthday')" v-slot="{ errors }" mode="lazy" slim>
                <select name="birthdayDay" id="day" v-model="form.birthdayDay" @change="existBirthdayInOwnerData()">
                  <option value="">-</option>
                  <option v-for="n in 31" v-bind:value="n">{{ n }}</option>
                </select>
</ValidationProvider>
                <span>日</span>
              </div>
            </div>
            <div class="item mb20">
              <div class="ttl_form">
                <label for="mobile_phonenum">電話番号</label>
              </div>
              <div class="part_form phonenum">
<ValidationProvider vid="fixedPhonenum1" name="fixedPhonenum1" :rules="''" v-slot="{ errors }" mode="lazy" slim>
                <input type="text" name="fixedPhonenum1" placeholder="03" v-model="form.fixedPhonenum1">
</ValidationProvider>
                <span>-</span>
<ValidationProvider vid="fixedPhonenum2" name="fixedPhonenum2" :rules="''" v-slot="{ errors }" mode="lazy" slim>
                <input type="text" name="fixedPhonenum2" placeholder="5577" v-model="form.fixedPhonenum2">
</ValidationProvider>
                <span>-</span>
<ValidationProvider vid="fixedPhonenum3" name="fixedPhonenum3" :rules="validationRulesForAuthData('fixed-phonenum')" v-slot="{ errors }" mode="lazy" slim>
                <input type="text" name="fixedPhonenum3" placeholder="1155" v-model="form.fixedPhonenum3">
</ValidationProvider>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="ttl_form">
              <label for="mail">確認用メール送付先</label>
            </div>
            <div class="part_form">
<ValidationProvider name="email" rules="email-required|email-email|email-exists:@id" v-slot="{ errors }" mode="lazy" slim>
	      <input type="text" name="email" placeholder="example@majesty-golf.com" v-model="form.email" @blur="processSubValidatedEmail()">
</ValidationProvider>
            </div>
          </div>
          <div class="txt_error" v-if="$refs['observer'] && $refs['observer']['flags']['invalid']">
            <p v-if="$refs['observer']['errors']['id'][0]">{{ $refs['observer']['errors']['id'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['birthdayYear'][0]">{{ $refs['observer']['errors']['birthdayYear'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['birthdayMonth'][0]">{{ $refs['observer']['errors']['birthdayMonth'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['birthdayDay'][0]">{{ $refs['observer']['errors']['birthdayDay'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['fixedPhonenum1'][0]">{{ $refs['observer']['errors']['fixedPhonenum1'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['fixedPhonenum2'][0]">{{ $refs['observer']['errors']['fixedPhonenum2'][0] }}</p>
            <p v-else-if="$refs['observer']['errors']['fixedPhonenum3'][0]">{{ $refs['observer']['errors']['fixedPhonenum3'][0] }}</p>
            <p v-if="!$refs['observer']['errors']['id'][0] && !isExistBirthdayInOwnerData">誕生日のご登録がございません</p>
            <p v-if="$refs['observer']['errors']['email'][0]">{{ $refs['observer']['errors']['email'][0] }}</p>
          </div>
<ul class="txt_s list_caution" style="text-align:left;"><li>※携帯メールアドレス（docomo/au/softbankのキャリアメール）でメール防止フィルターをご利用の場合は、【majesty_ownersclub@majesty-golf.com】を受信できるよう設定をお願いいたします。</li> <li>※YahooメールやGmailなどフリーメールの場合は、迷惑メールやゴミ箱に自動的に振り分けられている可能性がありますので、ご確認頂きますようお願いいたします。</li></ul>
          <div class="btnLogin">
            <button type="button" class="arrow" @click="submit()">登録用URL発行依頼</button>
          </div>
          <div class="txtLink">
            <p>【WEB登録済みの方】<br>
              <a href="/login/" class="txt_red">こちら</a>からログインしてください</p>
            <p>【マジェスティーオーナー様番号がご不明な方、エラーが出る方】<br>
              <a href="/login/customer/register/email/" class="txt_red">こちら</a>からご登録ください</p>
          </div>
        </form>
</ValidationObserver>
      </div>
    </div>
  </section>
</main>
</div>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email, integer, length } from 'vee-validate/dist/rules'
import Axios from 'axios'
import DateTime from '../datetime'
import String from '../string'

extend('id-required', {
  ...required,
  message: 'マジェスティオーナー様番号を入力してください。'
})

extend('id-integer', {
  ...integer,
  message: 'マジェスティオーナー様番号を正しく入力してください。'
})

extend('id-length', {
  ...length,
  message: 'マジェスティオーナー様番号を正しく入力してください。'
})

extend('id-exists', {
  validate: async (value) => {
    return await Axios.get('/api/exists_unregistered_owner_from_fm_by_login_id',
      {
        params: {
          login_id: value
        }
      })
      .then((res) => {
        if (res.data.status == 'success') {
          return true
        }
        else {
          return false
        }
      })
  },
  message: 'WEB登録済です。ログインにお進みください。'
})

extend('birthday-year-required', {
  ...required,
  message:  '誕生日を入力してください。'
})

extend('birthday-month-required', {
  ...required,
  message:  '誕生日を入力してください。'
})

extend('birthday-day-required', {
  ...required,
  message:  '誕生日を入力してください。'
})

extend('birthday-verify', {
  params: ['id', 'birthdayYear', 'birthdayMonth'],
  validate: async (value, { id, birthdayYear, birthdayMonth }) => {
    if (id && birthdayYear && birthdayMonth && value) {
      return await Axios.get('/api/verify_owner_birthday',
        {
          params: {
            loginId: id,
            birthdayYear: birthdayYear,
            birthdayMonth: birthdayMonth,
            birthdayDay: value
          }
        })
        .then((res) => {
          if (res.data.status == 'success') {
            return true
          }
          else {
            return false
          }
        })
    }
    else {
      return true
    }
  },
  message:  '誕生日を正しく入力してください。'
})

extend('auth-data-verify', {
  params: ['id', 'birthdayYear', 'birthdayMonth', 'birthdayDay', 'fixedPhonenum1', 'fixedPhonenum2', 'fixedPhonenum3'],
  validate: async (value, { id, birthdayYear, birthdayMonth, birthdayDay, fixedPhonenum1, fixedPhonenum2, fixedPhonenum3 }) => {
    if (id && ((birthdayYear && birthdayMonth && birthdayDay) || (fixedPhonenum1 && fixedPhonenum2 && fixedPhonenum3))) {
      return await Axios.get('/api/verify_owner_auth_data',
        {
          params: {
            loginId: id,
            birthdayYear: birthdayYear,
            birthdayMonth: birthdayMonth,
            birthdayDay: birthdayDay,
            fixedPhonenum1: fixedPhonenum1,
            fixedPhonenum2: fixedPhonenum2,
            fixedPhonenum3: fixedPhonenum3
          }
        })
        .then((res) => {
          if (res.data.status == 'success') {
            return true
          }
          else {
            return false
          }
        })
    }
    else {
      return true
    }
  },
  message:  '生年月日か電話番号のどちらかを正しく入力してください。'
})

extend('email-required', {
  ...required,
  message: 'メールアドレスを入力してください。'
})

extend('email-email', {
  ...email,
  message: 'メールアドレスを正しく入力してください。'
})

extend('email-exists', {
  params: ['id'],
  validate: async (value, { id }) => {
    return await Axios.get('/api/exists_owner_email', {
      params: {
        email: value,
        id: id
      }
    })
    .then((res) => {
      if (res.data.results == 'exists') {
        return false
      }
      else {
        return true
      }
    })
  },
  message: 'このメールアドレスは使用できません。'
})

extend('birthday-required', {
  ...required,
  message: '生年月日か電話番号のどちらかを正しく入力してください。'
})

extend('fixed-phonenum-required', {
  ...required,
  message: '生年月日か電話番号のどちらかを正しく入力してください。'
})

extend('mobile-phonenum-required', {
  ...required,
  message: '生年月日か電話番号のどちらかを正しく入力してください。'
})

export default {
  data: function () {
    return {
      form: {
        id: '',
        email: '',
        birthdayYear: '',
        birthdayMonth: '',
        birthdayDay: '',
        fixedPhonenum1: '',
        fixedPhonenum2: '',
        fixedPhonenum3: '',
      },
      isExistBirthdayInOwnerData: true
    }
  },
  mixins: [DateTime, String],
mounted: function () {
this.existBirthdayInOwnerData
},
  methods: {
    submit: function () {
      this.$refs.observer.validate()
      .then((res) => {
        if (res) {
          this.$root.$children[0].$set(this.$root.$children[0].$data, 'isLoading', true)
          let data = {
            loginId: this.form.id,
            birthdayYear: this.form.birthdayYear,
            birthdayMonth: this.form.birthdayMonth,
            birthdayDay: this.form.birthdayDay,
            fixedPhonenum1: this.form.fixedPhonenum1,
            fixedPhonenum2: this.form.fixedPhonenum2,
            fixedPhonenum3: this.form.fixedPhonenum3,
            email: this.form.email
          }

          Axios.post('/api/fm_registration/request_auth_email_code', data)
          .then((res) => {
            if (res.data.status == 'success') {
              this.$root.$children[0].$set(this.$root.$children[0].$data, 'form', this.form)
              this.$root.$children[0].$set(this.$root.$children[0].$data, 'currentView', 'FmRegistrationComplete')
            }

            this.$root.$children[0].$set(this.$root.$children[0].$data, 'isLoading', false)
          })
        }
      })
    },
    processSubValidatedEmail: function () {
      this.$set(this.$data.form, 'email', this.subValidatedEmail(this.form.email))
    },
    existBirthdayInOwnerData: function () {
      if (this.form.id && this.form.birthdayYear && this.form.birthdayMonth && this.form.birthdayDay) {
        Axios.get('/api/is_exist_birthday_in_owner_data', {
          params: {
            loginId: this.form.id
          }
        })
        .then((res) => {
          if (res.data.status == 'blank') {
            this.$set(this.$data, 'isExistBirthdayInOwnerData', false)
          }
          else {
            this.$set(this.$data, 'isExistBirthdayInOwnerData', true)
          }
        })
        .catch((e) => {
          this.$set(this.$data, 'isExistBirthdayInOwnerData', true)
        })
      }
      else {
        this.$set(this.$data, 'isExistBirthdayInOwnerData', true)
      }
    }
  },
  computed: {
    validationRulesForAuthData: function () {
      const self = this

      return function (type) {
        const required = type + '-required'

        if (!(self.form.birthdayYear && self.form.birthdayMonth && self.form.birthdayDay) && !(self.form.fixedPhonenum1 && self.form.fixedPhonenum2 && self.form.fixedPhonenum3)) {
          return required
        }
        else if ((type == 'birthday' && self.form.birthdayYear && self.form.birthdayMonth && self.form.birthdayDay) || (type == 'fixed-phonenum' && self.form.fixedPhonenum1 && self.form.fixedPhonenum2 && self.form.fixedPhonenum3)) {
          return 'auth-data-verify:@id,@birthdayYear,@birthdayMonth,@birthdayDay,@fixedPhonenum1,@fixedPhonenum2,@fixedPhonenum3'
        }
        else {
          return ''
        }
      }
    }
  }
}
</script>
